module.exports = "https://web-assets-production.autolist.com/_next/static/images/street-wreath-bd06920dccd2afb828397253bd214927.svg";